<template>
  <div class="mybox">
    <div class="topBox">
      <!-- 头部 -->
      <div class="head">
        <img class="img_arrow" src="@/assets/test/return.png" alt @click="goBack()">
        <p class="my_title">发布回答</p>
        <button
          style="border: none;width: 80px"
          :disabled="isdisabled"
          :class="{ garybtn: isdisabled == true }"
          @click="save()"
        >{{ msg.isEdiWd ? "修改":"发布" }}</button>
      </div>
      <!-- <div style="height:50px;"></div> -->
      <div class="maxbox">
        <!-- 文字 -->
        <div class="test">
          <div class="inp_box">
            <textarea id="" v-model="testVal" :placeholder="textareaval" class="ipts" name="" cols="30" rows="10" @click="offemil"></textarea>
          </div>
        </div>
      </div>
      <!-- xiaolian -->
      <div class="smile">
        <img src="@/assets/myicon/smile.png" alt="" @click="showemoji()">
      </div>
      <!-- 图片 -->
      <div class="photo">
        <van-uploader
          v-model="fileList"
          upload-icon="plus"
          style="@uploader-size: 80px;"
          multiple
          :max-count="9"
          :after-read="afterRead"
          :before-delete="delafterRead"
          @uploader-size="222"
        />
      </div>
      <div v-html="inners"></div>
    </div>

    <!-- 表情 -->
    <div v-show="is_emoji" class="fot_menu">
      <div class="emoji_box">
        <div class="emoji_div">
          <!-- <div v-for="(item,index) in emojiArr" :key="index" class="emoji_text">
                  <img :src="item.key" alt="">
                </div> -->
          <emotion
            v-show="emotionShow"
            ref="emotion"
            class="emotion"
            :height="90"
            @emotion="handleEmotion"
          ></emotion>
        </div>
        <!-- <div class="emoji_send">
            <span class="emoji_btn" @click="send_emoji">发送</span>
              <span class="del_emoji" @click="del_emoji">
              <img src="@/assets/emotion_del.png" alt="">
            </span>
          </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Emotion from '@/components/emotion/index'

import { reply, edlQa } from '@/api/course.js'
import { Toast } from 'vant'
import Cookies from 'js-cookie'
export default {
  components: {
    Emotion
  },
  props: {
    msg: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      inners: '',
      testVal: '',
      message_html: '',
      textareaval: '',
      avator: '',
      emotionShow: true,
      is_emoji: false,
      fileList: [],
      photoList: [],
      isdisabled: true,
      ipt: '',
      strMap: {},
      mydata: {},
      isUpload: true
    }
  },
  watch: {
    testVal: {
      deep: true,
      handler(n, o) {
        console.log(n)
        if (n != '') {
          this.isdisabled = false
        } else {
          this.isdisabled = true
        }
      }
    }
  },
  mounted() {
    // this.mydata = JSON.parse(this.$route.query.params)
    console.log(this.msg)
    this.getAvator()
    this.testVal = this.msg.content_before
    this.fileList = this.msg.fileList
    this.textareaval = `回复  ${this.msg.to_username}：`
  },
  methods: {
    offemil() {
      this.is_emoji = false
    },
    showemoji() {
      if (!this.is_emoji) {
        this.is_emoji = true
        document.activeElement.blur()
      } else {
        this.is_emoji = false
      }
    },
    handleEmotion(i) {
      this.testVal += `${i}`
    },
    getAvator() {
      var uid = Cookies.get('uid')
      const domain = 'https://avatar.zhulong.com/avatar/'
      let num = uid
      const n = 9
      let len = num.toString().length
      while (len < n) {
        num = '0' + num
        len++
      }
      uid = num
      const dir1 = uid.substr(0, 3)
      const dir2 = uid.substr(3, 2)
      const dir3 = uid.substr(5, 2)
      this.avator = domain + dir1 + '/' + dir2 + '/' + dir3 + '/' + uid.substr(-2) + '_avatar_big.jpg'
      return this.avator
    },
    getNowFormatDate() {
      var date = new Date()
      var seperator1 = '-'
      var seperator2 = ':'
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      var min = date.getMinutes()
      var hou = date.getHours()
      var sec = date.getSeconds()
      if (hou >= 1 && hou <= 9) {
        hou = '0' + hou
      }
      if (min >= 1 && min <= 9) {
        min = '0' + min
      }
      if (sec >= 1 && sec <= 9) {
        sec = '0' + sec
      }
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate =
              date.getFullYear() +
              seperator1 +
              month +
              seperator1 +
              strDate +
              ' ' + hou +
              seperator2 +
              min +
              seperator2 +
              sec
      return currentdate
    },
    save() {
      console.log(this.isUpload + '--2222----')

      if (!this.isUpload) {
        Toast('请等待图片上传完成')
        return
      }
      this.isdisabled = true
      console.log('=========' + JSON.stringify(this.msg.fileList))
      if (this.msg.isEdiWd) {
        let url = ''
        const urlList = []
        for (let i = 0; i < this.msg.fileList.length; i++) {
          urlList.push(this.msg.fileList[i].url)
          if (i == this.msg.fileList.length - 1) {
            url += this.msg.fileList[i].url
          } else {
            url += this.msg.fileList[i].url + ','
          }
        }
        var data = {
          id: this.msg.id,
          content: this.testVal,
          images: url
        }
        edlQa(data).then((res) => {
          if (res.errNo === 0) {
            this.extracted(this.msg.id, urlList)
          } else {
            this.isdisabled = false
            Toast(res.msg)
          }
        })
      } else {
        // eslint-disable-next-line no-redeclare
        var data = {
          lesson_id: this.msg.lesson_id,
          content: this.testVal,
          images: this.photoList.toString(),
          parent_id: this.msg.parent_id,
          question_id: this.msg.question_id,
          to_username: this.msg.to_username,
          to_uid: this.msg.to_uid
        }
        console.log(data)
        reply(data).then((res) => {
          if (res.errNo === 0) {
            this.extracted(res.result, this.photoList)
          } else {
            this.isdisabled = false
            Toast(res.msg)
          }
        })
      }
    },
    extracted(id, url) {
      this.isdisabled = false
      Toast(this.msg.isEdiWd ? '修改成功' : '回复成功')
      console.log(this.msg.to_uid, 'this.msg.to_uid')

      var obj = {
        avatar: this.getAvator(),
        username: Cookies.get('username') ? Cookies.get('username') : this.msg.username,
        to_username: this.msg.to_username,
        uid: this.msg.to_uid,
        images: url,
        create_time: this.getNowFormatDate(),
        content: this.testVal,
        question_id: this.msg.question_id,
        content_before: this.testVal,
        parent_id: this.msg.parent_id,
        user_type: 2,
        isParent: this.msg.isParent,
        p_index: this.msg.p_index,
        s_index: this.msg.s_index,
        id: id,
        is_edit: true,
        count: this.msg.count,
        replyMsg: this.msg.replyMsg,
        page: this.msg.page,
        isEdiWd: this.msg.isEdiWd,
        to_user_type: Cookies.get('uid') == this.msg.to_uid ? 2 : this.msg.to_user_type,
        sendtype: this.msg.sendtype
      }
      console.log(this.getNowFormatDate())
      this.$emit('childFns', obj)
      this.$emit('childFn', this.msg.scrollTop)
      this.$parent.type = 1
      this.$parent.styleChange()
    },
    afterRead(e) {
      this.isUpload = false
      if (e instanceof Array) {
        e.forEach((item, index) => {
          const fd = new FormData()
          fd.append('files', item.file)
          axios
            .post('https://f.zhulong.com/uploadZhulongImgForEdit.php', fd)
            .then((res) => {
              this.photoList.push(res.data.url)
              if (this.msg.fileList) {
                this.msg.fileList.push({ url: res.data.url })
              }
              if (e.length - 1 === index) {
                this.isUpload = true
                console.log(this.isUpload + '--2222----')
              }
            })
        })
      } else {
        const fd = new FormData()
        fd.append('files', e.file)
        axios
          .post('https://f.zhulong.com/uploadZhulongImgForEdit.php', fd)
          .then((res) => {
            this.photoList.push(res.data.url)
            if (this.msg.fileList) {
              this.msg.fileList.push({ url: res.data.url })
            }
            this.isUpload = true
            console.log(this.isUpload + '--3333----')
          })
      }
    },
    delafterRead(e, d) {
      console.log(d.index + '--------长度-11---------' + this.fileList.length + '----' + JSON.stringify(this.msg.fileList))
      if (this.msg.fileList) {
        this.msg.fileList.splice(d.index, 1)
      }
      this.photoList.splice(d.index, 1)
      console.log(d.index + '-----------长度-------' + this.fileList.length + '----' + JSON.stringify(this.msg.fileList))
    },
    goBack() {
      this.$parent.type = 1
      console.log(this.msg.scrollTop)
      this.$emit('childFn', this.msg.scrollTop)
      document.documentElement.scrollTop = this.msg.scrollTop
    }

  }
}
</script>

<style lang="scss" scoped>
  /deep/ .van-uploader__preview-delete{
    width: 30px;
    height: 30px;
    background-color: #ee2e2e;
    border-radius: 0px 0px 0px 10px;
    border-left: 1px solid #fff;
    border-bottom: 1px solid #fff;
  }
  /deep/ .van-uploader__preview-delete-icon{
    top: 0;
    right: 0;
  }
  .photo{
    margin-top: 20px;
  }
  .topBox{
    padding-bottom: 300px;
  }
  .fot_menu{
    position: fixed;
    bottom: 0;
    background: #fff;
  }
  /deep/ .emotion-box{
    width: 750px;
  }
  .ipts{
    height: 300px;
    width: 95%;
    color: #333;
  }
  .maxbox{
    margin: 92px 0 0 0;
  }
  .inp_box {
    padding: 10px 0 0 20px;
    .msg_box {
      outline: none;
      width: 100%;
    }
    .edit_box {
      min-height: 200px;
      width: 95%;
    }
  }

  .smile{
    width: 100%;
    height: 50px;
  }
  .smile img{
    float: right;
    margin: 0 30px 0 0;
    width: 44px;
    height: 44px;
  }
  .garybtn{
    background: rgba(238,46,46,0.62) !important;
  }
  /deep/ .van-uploader__preview-image{
    width: 222px;
    height: 222px;
  }
  /deep/ .van-uploader__upload{
    width: 222px;
    height: 222px;
  }
  /deep/ .van-uploader__wrapper{
    margin: 0 0 0 25px;
  }
  .test{
    width: 100%;
    margin: 0px 0 0 0;
    textarea{
      width: 90%;
      font-size: 30px;
      color: #333;
      margin: 10px 0 0 10px;
      border: none;
      resize: none;
      min-height: 200px;
    }
  }
  .head {
    width: 100%;
    height: 90px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    border-bottom: 1px solid #eee;
    button{
      font-size: 30px;
      margin: 0 20px 0 0;
      width: 120px;
      height: 56px;
      color: #fff;
      border-radius: 8px;
      background: #ee2e2e;
    }
  }
  .img_arrow {
    width: 45px;
    height: 50px;
    padding-left: 30px;
    padding-top: 9px;
  }
  .my_title {
    font-weight: 500;
    color: #333;
    font-size: 36px;
    /* font-weight: 600; */
    letter-spacing: 2px;
    padding-left: 60px;
  }
</style>
